import { defineComponent, ref, watch } from "vue";
import MemberInfo from "../MemberItemCommon/MemberInfo.vue.mjs";
import MemberControl from "../MemberControl/index.mjs";
import useMemberItem from "./useMemberItemHooks.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexPC",
  props: {
    userInfo: null
  },
  setup(__props) {
    const props = __props;
    const { isMemberControlAccessible, openMemberControl, closeMemberControl } = useMemberItem(props.userInfo);
    const showMemberControl = ref(false);
    watch(isMemberControlAccessible, (accessible) => {
      showMemberControl.value = accessible;
    });
    return { __sfc: true, props, isMemberControlAccessible, openMemberControl, closeMemberControl, showMemberControl, MemberInfo, MemberControl };
  }
});
export {
  _sfc_main as default
};
